module.exports = __webpack_public_path__ + "static/media/numeric.39141255.png";